<template>
<div class="common-input-wrapper">
  <label class="common-label" v-bind:class="{'common-label--error': isError}">{{label}}</label>
  <input
    type="text" v-bind:name="name" ref="textInput" :value="value" @input="update()"  class="common-input" v-bind:class="{ 'common-input--disabled': isDisabled, 'common-input--error': isError }" />
  <span class="error-input-message" v-if="isError">
    <span v-if="error">
      {{ error }}
    </span>
    <span v-else>
      Required *
    </span>
  </span>
</div>
</template>

<script>
  export default {
    name: 'UXInput',
    props: {
      value: String,
      label: String,
      name: String,
      isDisabled: Boolean,
      isError: Boolean,
      error: String
    },
    methods: {
      update: function () {
        this.$emit('input', this.$refs.textInput.value);
      }
    },
    computed: {
    }
  }
</script>
